import { snapshot } from 'valtio';
import { Nullable } from 'common-types';
import { isDevelopment } from 'env-utils';
import { logger } from 'logging-utils';
import mockData from '../feature-flags-mock-data.json';
import { AppFeature } from '../feature-flags-types';
import {
  AppFeatureFlagsStore,
  AppFeatureFlagsStoreState,
} from '../stores/feature-flags-store';

const setEmptyFeatureFlags = (): void => {
  Object.keys(AppFeature).forEach(key => {
    AppFeatureFlagsStore[key as AppFeature] = false;
  });
};

const updateFeatureFlagsStore = (
  appFeatureFlags: AppFeatureFlagsStoreState,
): void => {
  Object.values(AppFeature).forEach(val => {
    const appFeature = val as AppFeature;
    AppFeatureFlagsStore[appFeature] = appFeatureFlags[appFeature] || false;
  });
};

export const initFeatureFlags = (): void => {
  try {
    if (isDevelopment()) {
      updateFeatureFlagsStore(mockData.featureFlags.app);
      return;
    }

    const userConfig = localStorage.getItem('user');
    if (!userConfig) {
      return setEmptyFeatureFlags();
    }

    const parsedUserConfig = JSON.parse(userConfig);
    updateFeatureFlagsStore(parsedUserConfig.featureFlags.app);
  } catch (err) {
    logger.error(
      'Unable to init feature flags due to the following error',
      err,
    );
    return setEmptyFeatureFlags();
  }
};

export const isFeatureEnabled = (feature: AppFeature): Nullable<boolean> => {
  const appFeatureFlags = snapshot(AppFeatureFlagsStore);
  return appFeatureFlags[feature];
};
